export const dashboardMetrics = [
  { label: "Famílias ativas", value: "428", delta: "+18 no mês" },
  { label: "Planos funerários", value: "392", delta: "91,6% da base" },
  { label: "Telemedicina", value: "174", delta: "+31 no mês" },
  { label: "Recebido no mês", value: "R$ 42.840", delta: "Demo sintética" },
  { label: "Inadimplência", value: "6,2%", delta: "-0,8 p.p." },
  { label: "Comissão elegível", value: "R$ 4.280", delta: "15 vendedores" },
];

export const customers = [
  {
    id: "customer-1",
    name: "Família Oliveira",
    holder: "Carlos Oliveira",
    phone: "(41) 9****-0182",
    funeral: "ATIVO",
    telemedicine: "ATIVO",
    seller: "Vendedor Demo 01",
    balance: "Em dia",
  },
  {
    id: "customer-2",
    name: "Família Santos",
    holder: "Márcia Santos",
    phone: "(41) 9****-7740",
    funeral: "CARÊNCIA",
    telemedicine: "NÃO CONTRATADA",
    seller: "Vendedor Demo 02",
    balance: "Em dia",
  },
  {
    id: "customer-3",
    name: "Família Almeida",
    holder: "João Almeida",
    phone: "(41) 9****-2119",
    funeral: "SUSPENSO",
    telemedicine: "ATIVO",
    seller: "Vendedor Demo 03",
    balance: "Vencido",
  },
];

export const sales = [
  {
    id: "sale-1",
    createdAt: "19/09/2026 10:42",
    customer: "Carlos Oliveira",
    offer: "Combo Funeral + Saúde",
    seller: "Vendedor Demo 01",
    source: "EVA / WhatsApp",
    status: "AGUARDANDO PAGAMENTO",
    amount: "R$ 98,90",
  },
  {
    id: "sale-2",
    createdAt: "19/09/2026 09:18",
    customer: "Márcia Santos",
    offer: "Plano Funerário",
    seller: "Vendedor Demo 02",
    source: "Link do vendedor",
    status: "ASSINADO",
    amount: "R$ 59,00",
  },
  {
    id: "sale-3",
    createdAt: "18/09/2026 16:05",
    customer: "João Almeida",
    offer: "Telemedicina",
    seller: "Vendedor Demo 03",
    source: "EVA / Campanha",
    status: "ATIVO",
    amount: "R$ 39,90",
  },
];

export const contracts = [
  {
    number: "CON-000101",
    customer: "Carlos Oliveira",
    type: "Funeral",
    status: "AGUARDANDO ASSINATURA",
    version: "v1",
    updatedAt: "19/09/2026",
  },
  {
    number: "CON-000102",
    customer: "Carlos Oliveira",
    type: "Telemedicina",
    status: "ASSINADO",
    version: "v1",
    updatedAt: "19/09/2026",
  },
  {
    number: "LEG-000018",
    customer: "Márcia Santos",
    type: "Legado",
    status: "ATIVO",
    version: "Papel",
    updatedAt: "15/09/2026",
  },
];

export const invoices = [
  {
    number: "FAT-000221",
    customer: "Carlos Oliveira",
    products: "Funeral + Telemedicina",
    dueDate: "25/09/2026",
    total: "R$ 98,90",
    status: "ABERTA",
    method: "PIX",
  },
  {
    number: "FAT-000220",
    customer: "Márcia Santos",
    products: "Funeral",
    dueDate: "20/09/2026",
    total: "R$ 59,00",
    status: "PAGA",
    method: "BOLETO",
  },
  {
    number: "FAT-000217",
    customer: "João Almeida",
    products: "Funeral",
    dueDate: "10/09/2026",
    total: "R$ 59,00",
    status: "VENCIDA",
    method: "BOLETO",
  },
];

export const commissions = [
  {
    seller: "Vendedor Demo 01",
    product: "Combo",
    sale: "PED-000301",
    amount: "R$ 25,00",
    status: "AGUARDANDO ELEGIBILIDADE",
  },
  {
    seller: "Vendedor Demo 02",
    product: "Funeral",
    sale: "PED-000299",
    amount: "R$ 20,00",
    status: "ELEGÍVEL",
  },
  {
    seller: "Vendedor Demo 03",
    product: "Telemedicina",
    sale: "PED-000294",
    amount: "R$ 10,00",
    status: "PAGA",
  },
];

export const integrations = [
  { provider: "EVA", mode: "FAKE", status: "SAUDÁVEL", lastEvent: "há 2 min" },
  { provider: "PAGLOG", mode: "FAKE", status: "SAUDÁVEL", lastEvent: "há 3 min" },
  { provider: "MOBIMEDICAL", mode: "FAKE", status: "SAUDÁVEL", lastEvent: "há 8 min" },
  { provider: "ASSINATURA", mode: "FAKE", status: "SAUDÁVEL", lastEvent: "há 5 min" },
];

export const telemedicine = [
  {
    person: "Carlos Oliveira",
    family: "Família Oliveira",
    externalId: "fake_beneficiary_001",
    status: "ATIVO",
    firstAccess: "Enviado",
  },
  {
    person: "Ana Oliveira",
    family: "Família Oliveira",
    externalId: "fake_beneficiary_002",
    status: "ATIVO",
    firstAccess: "Concluído",
  },
  {
    person: "João Almeida",
    family: "Família Almeida",
    externalId: "fake_beneficiary_003",
    status: "ATIVO",
    firstAccess: "Concluído",
  },
];
